import { render, staticRenderFns } from "./ConfirmLogoutSessions.vue?vue&type=template&id=9e64b5fa&"
import script from "./ConfirmLogoutSessions.vue?vue&type=script&lang=js&"
export * from "./ConfirmLogoutSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports